import { APIHandler } from "../../base";
import {
    CreateIntegrationRequest,
    SetProviderRequest,
    SetSignedIdentityRequest,
    UpdateIntegrationRequest
} from "../../../common/interfaces/admin/integration.interface";

export const fetchIntegrations = (companyId: number) =>
    APIHandler.get(`/admin/${companyId}/integrations`);

export const fetchIntegration = (companyId: number, id: string) =>
    APIHandler.get(`/admin/${companyId}/integrations/${id}`);

export const createIntegration = (companyId: number, data: CreateIntegrationRequest) =>
    APIHandler.post(`/admin/${companyId}/integrations`, data);

export const updateIntegration = (companyId: number, id: string, data: UpdateIntegrationRequest) =>
    APIHandler.patch(`/admin/${companyId}/integrations/${id}`, data);

export const deleteIntegration = (companyId: number, id: string) =>
    APIHandler.delete(`/admin/${companyId}/integrations/${id}`);

export const activateIntegration = (companyId: number, id: string) =>
    APIHandler.post(`/admin/${companyId}/integrations/${id}/activate`);

export const deactivateIntegration = (companyId: number, id: string) =>
    APIHandler.post(`/admin/${companyId}/integrations/${id}/deactivate`);

// --- SSO (sso_redirect) provider configuration ---------------------------

/** Create/update the Firebase SSO provider. IdP details go to Firebase, never stored (SR-1). */
export const setIntegrationProvider = (companyId: number, id: string, data: SetProviderRequest) =>
    APIHandler.post(`/admin/${companyId}/integrations/${id}/provider`, data);

/** Delete the SSO provider and deactivate the integration. */
export const deleteIntegrationProvider = (companyId: number, id: string) =>
    APIHandler.delete(`/admin/${companyId}/integrations/${id}/provider`);

/** SP-side values (entity ID / ACS / redirect URI) for the customer's IdP team. */
export const fetchIntegrationSpConfig = (companyId: number, id: string) =>
    APIHandler.get(`/admin/${companyId}/integrations/${id}/sp-config`);

/** SAML SP metadata XML (string body) for IdP import. */
export const fetchIntegrationSpMetadataXml = (companyId: number, id: string) =>
    APIHandler.get(`/admin/${companyId}/integrations/${id}/sp-metadata.xml`, {
        responseType: "text"
    });

/** Record an SSO test result by tenant-verifying an admin sign-in ID token (FR-11). */
export const testIntegrationSso = (companyId: number, id: string, idToken: string) =>
    APIHandler.post(`/admin/${companyId}/integrations/${id}/test-sso`, { idToken });

// --- Signed identity (signed_identity) configuration ---------------------

/** Configure/rotate the signed-identity hand-off. Secret/JWKS → Secrets Manager (SR-1). */
export const setIntegrationSignedIdentity = (
    companyId: number,
    id: string,
    data: SetSignedIdentityRequest
) => APIHandler.post(`/admin/${companyId}/integrations/${id}/signed-identity`, data);
